import axios from 'axios';
import {
  TERMS_BRAND,
  TERMS_DOCUMENT,
  type SignUpLead,
} from '../../domain/entities/lead.entity';
import type { LeadDatasource } from '../repositories/lead.repository.impl';

/**
 * Registra o aceite das políticas no serviço de políticas da Primum —
 * **idêntico ao `enamed-feedback-lp`** (o mesmo endpoint do formulário do
 * SINAREM), com o mesmo corpo.
 *
 * Serviço à parte da nossa API (host próprio, sem o nosso token): por isso
 * `axios` direto, e não o `apiClient`.
 */
export class TermsDatasource implements LeadDatasource {
  async acceptLatest(lead: SignUpLead): Promise<void> {
    const baseUrl = import.meta.env.VITE_POLICIES_URL;
    const pageUrl = window.location.href;
    await axios.post(
      `${baseUrl}/api/terms/${TERMS_BRAND}/${TERMS_DOCUMENT}/accept-latest/`,
      {
        email: lead.email,
        extra_fields: {
          nome: lead.fullName,
          phone: lead.phone,
          pageUrl,
          acceptanceOrigin: pageUrl,
          // O SINAREM manda o país do formulário dele; aqui não há campo de
          // país, e a chave segue no corpo para o formato não divergir.
          address: '',
        },
      },
    );
  }
}
